import {Col, Row} from 'antd';
import React from 'react';

import BoxContent from '../../../../components/BoxContent/BoxContent';
import InformativeText from '../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../utils/commonFunctions';
import LabelChart from '../../components/LabelChart';
// import TotalChartList from '../../components/TotalChartList';
import ValueRepresentationBox from '../../components/ValueRepresentationBox';
// import ValueRepresentationBox from '../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../constants/commonConstants';
import AllSuppliers from '../../supplyChain/utils/AllSuppliers';

const OperationalAsset: React.FC<{data: any[]}> = ({data}) => {
  const assetInformative = InformativeText?.NZM?.asset;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(926)}}>
        <Col span={7}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(926)}}>
            <Col span={24}>
              <LabelChart
                data={data}
                keyArray={[
                  'emissions from leased asset',
                  'upstream emissions from leased asset',
                  'downstream emissions from leased asset'
                ]}
                chartType="progress"
                tooltip={assetInformative.Emissions_from_leased_assets}
                customLabel="Total Emissions"
              />
            </Col>
            <Col span={24}>
              <LabelChart
                data={data}
                keyArray={[
                  'emissions per leased asset',
                  'upstream emissions per leased asset',
                  'downstream emissions per leased asset'
                ]}
                chartType="progress"
                tooltip={assetInformative.Emissions_per_leased_assets}
                customLabel="Total Emissions"
              />
            </Col>
          </Row>
        </Col>
        <Col span={13}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(926)}}>
            <AllSuppliers
              data={data}
              keyArray={['total carbon emissions waste per facility']}
              type="asset"
            />
          </Row>
        </Col>
        <Col span={4}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(926)}}>
            <Col span={24} style={{height: convertPxToRem(239.5)}}>
              <ValueRepresentationBox
                data={data}
                mainKey="franchise carbon intensity"
                tooltip={assetInformative.Franchise_Carbon_Intensity}
                smallImage={true}
              />
            </Col>
            <Col span={24} style={{height: convertPxToRem(666)}}>
              <BoxContent />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default OperationalAsset;
